import { render, staticRenderFns } from "./VariationCard.vue?vue&type=template&id=6de4b74c&scoped=true"
import script from "./VariationCard.vue?vue&type=script&lang=js"
export * from "./VariationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de4b74c",
  null
  
)

export default component.exports